/** Cloud Function endpoint for the materials price update agent. */
export const MATERIALS_PRICE_AGENT_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/materialsPriceAgentApi';

export const MATERIALS_PRICE_AGENT_GUIDE_URL =
  'https://clients.lctimberframes.com/docs/agents/materialsPriceAgent.json';
